<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Fecha Desde"
            label-for="fechaDesde"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model="filtro.fechaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Fecha Hasta"
            label-for="fechaHasta"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model="filtro.fechaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            :label-cols="labelCols"
            horizontal>
            <b-form-checkbox 
                id="sortByDescending"
                v-model="filtro.sortByDescending"
                :value= "Boolean(true)"
                :unchecked-value= "Boolean(false)">
                Ordenar exports en forma descendente
            </b-form-checkbox>
          </b-form-group>
        </b-form>

        <!-- <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
        </div> -->
      </b-collapse>
      <div slot="footer" v-if="showOpcionesFiltro">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        sortByDescending: false
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2
    }
  },
  created() {
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
    },
  },
}
</script>

<style>
</style>
